import { render, staticRenderFns } from "./EmailLogsList.vue?vue&type=template&id=cd720124&"
import script from "./EmailLogsList.vue?vue&type=script&lang=js&"
export * from "./EmailLogsList.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports